"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationNumberItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PaginationItemMixin = require("../../mixins/components/PaginationItemMixin");
/**
 * Used by the `Pagination` component to house the page number buttons based on `PaginationButton`.
 *
 * @since 7.42.0
 */
var PaginationNumberItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "PaginationNumberItem",
  componentId: "c11n-8-107-0__sc-i6f8qs-0"
})(["", ""], _PaginationItemMixin.PaginationItemMixin);
exports.PaginationNumberItem = PaginationNumberItem;
PaginationNumberItem.displayName = 'PaginationNumberItem';

/** @component */